import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { asStyledComponent } from '@clds/component-enhancer';
import { typographyMixin } from '@clds/typography';
import { formTheme } from './theme.js';
const Root = styled.label `
  display: block;
  ${typographyMixin(formTheme.label.typography)};
  margin: ${formTheme.label.margin.vertical} 0;
  cursor: pointer;
`;
const Mandatory = styled.span `
  ${typographyMixin(formTheme.label.mandatoryTypography)};
`;
export const Label = asStyledComponent(({ mandatory, children, ...rest }) => (_jsxs(Root, { ...rest, children: [children, mandatory && _jsx(Mandatory, { children: "\u00A0*" })] })));
